import { debounce } from 'debounce'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import FilterBar from '@modules/admin/shared/FiltersBar'
import Loading from '@modules/core/components/Loading'
import CustomPagination from '@modules/tableComponents/Pagination'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import SelectField from '@modules/formFields/SelectField'
import React, { Component } from 'react'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import AccessControl from '../../auth/AccessControl'
import { DerivationsTable } from './Derivation.Index.Table'

class DerivationIndex extends Component {
  state = {
    derivations: [],
    search: '',
    page: null,
    pageSize: 50,
    total: 0,
    isFetching: false,
    companyFilter: undefined,
    typeFilter: undefined,
  }

  handleChangePage = (page) => {
    return this.setState({ page }, this.fetchDerivations)
  }

  onTypeSearch = (search) => {
    return this.setState({ search, page: 1 }, this.debouncedFetch)
  }
  fetchDerivations = () => {
    const { page, pageSize, search } = this.state
    this.setState({ isFetching: true })

    const filters = {
      company_api_keys: this.state.companyFilter ? this.state.companyFilter.map((co) => co.api_key) : undefined,
      type: this.state.typeFilter,
    }

    return Consultations.externalDerivations
      .index({ page, pageSize, search, ...filters })
      .then((response) => {
        this.setState({
          derivations: response.data,
          page: response.meta.current_page,
          lastPage: response.meta.last_page,
          total: response.meta.total,
          isFetching: false,
        })
      })
      .catch((err) => {
        console.error(err)
        this.setState({ isFetching: false, sentences: [] })
      })
  }
  debouncedFetch = debounce(this.fetchDerivations, 350, false)

  componentDidMount() {
    this.fetchDerivations()
  }

  render() {
    const { derivations, isFetching, total, search, typeFilter } = this.state
    const { t } = this.props
    return (
      <div>
        <DashboardHeader title={<Trans>Derivaciones</Trans>} total={total}>
          <Link to={`derivations/create`} className="btn btn-primary">
            <Trans>Crear</Trans>
          </Link>
        </DashboardHeader>

        <FilterBar value={search} onChange={this.onTypeSearch}>
          <AccessControl>
            <SelectCompanyField
              placeholder={t('Compañías')}
              multi
              input={{
                value: this.state.companyFilter,
                onChange: (companies) => this.setState({ companyFilter: companies, page: 1 }),
              }}
            />
          </AccessControl>

          <SelectField
            simpleValue
            placeholder={t('Tipo de enlace')}
            input={{
              value: typeFilter,
              onChange: (typeFilter) => this.setState({ typeFilter }),
            }}
            options={[
              { id: 'url', name: t('Enlace web') },
              { id: 'phone', name: t('Teléfono') },
            ]}
          />
        </FilterBar>

        <Loading isFetching={isFetching} />
        <DerivationsTable derivations={derivations} />

        <CustomPagination
          onClickItem={this.handleChangePage}
          activePage={this.state.page}
          totalPages={this.state.lastPage}
          maxButtons={7}
        />
      </div>
    )
  }
}

export default withTranslation()(DerivationIndex)
